//  单品页商城比价 popover trend

import '../../css/product_where_buy_module.css'
import '../../css/popup_price_trend.css'
import PopupTrend2 from './popup_price_trend'
import { isInView, docCookies as Cookies } from '../../js/utils/utils'
import utils from '../../js/utils/utils'
import ProductSame from '../../Service/ProductSame'
import { formatNum, keep2Decimals } from '../../js/utils/Number'
import PopupTrend from '../../components/PopupTrend'

import Vue from 'vue'

const isBjg = location.hostname.includes('bijiago')
const apiPrefix = isBjg ? '/bjg' : ''

if (!window.PopupTrend) {
  window.PopupTrend = PopupTrend2
}

const tpl = $('#tpl_now').text()
var _promotions = []
var loaded_dpids = [],
  dp_currencies = []

// function hoverPriceHistory () {
//     $('#tab_wrap #tab_where_buy .popup-trend').hover(function () {
//         var trend_area = $(this).siblings('.popup-trend-area');
//         var position = trend_area.data('position');
//         var site_name = $(this).data('site-name').toString();
//         var show_chart_legend = true;
//         var serie_name = '到手价(单件)'
//         var istb = false
//         if (site_name.indexOf('天猫') >= 0 || site_name.indexOf('淘宝') >= 0) {
//             istb = true;
//             serie_name = '页面价';
//             show_chart_legend = false;
//         }
//         var dp_id = $(this).parents('.dp-item').data('dp-id');
//         var chart_id = '';
//         var quan_price = $(this).attr('quan-price');
//         if (quan_price === undefined) quan_price = '';
//
//         var serie = null;
//         var promo_serie = null;
//
//         if (loaded_dpids.indexOf(dp_id + '-' + position) !== -1) {
//             // 已经加载过
//             trend_area.toggleClass('active');
//
//             PopupTrend.config({
//                 popup_dom: trend_area,
//                 istb: istb,
//                 dp_id: dp_id,
//                 promotions: _promotions[dp_id + '-' + position],
//                 quan_price: Number(quan_price),
//                 currency: dp_currencies[dp_id] ? dp_currencies[dp_id] : '&yen;',
//             })
//         } else {
//             trend_area.css('left', $(this).position().left + 4 + 'px');
//             trend_area.toggleClass('active');
//             chart_id = trend_area.children('.area-content').attr('id');
//
//             trend_data.get_trend_data('',dp_id, quan_price,'',function (data) {
//                 loaded_dpids.push(dp_id + '-' + position);
//                 if (data && data.is_ban !== undefined && data.is_ban == 1) {
//                     window.location.href = resp.action.to;
//                     return;
//                 }
//
//                 if (data.currency) { dp_currencies[dp_id] = data.currency; }
//
//                 _promotions[dp_id + '-' + position] = [];
//                 if (data.promo_detail !== undefined) {
//                     _promotions[dp_id + '-' + position] = data.promo_detail;
//                 }
//
//                 if (data.promo_series !== undefined) {
//                     if (data.promo_series.length > 2)
//                         promo_serie = data.promo_series[1];
//                     else promo_serie = data.promo_series[data.promo_series.length-1];
//
//                     promo_serie.site_name = site_name;
//                     promo_serie.series_name = '到手价(多件)';
//                     promo_serie.is_promo = true;
//                 } else {
//                     promo_serie = null;
//                 }
//
//                 if (data.series && data.series.length) {
//                     if (data.series.length > 2)
//                         serie = data.series[1];    // 默认展示180天
//                     else serie = data.series[data.series.length-1];
//
//                     serie.site_name = site_name;
//                     serie.series_name = serie_name;
//                     serie.is_promo = false;
//                 } else {
//                     serie = null;
//                 }
//
//                 if (serie && serie.data) {
//                     if (serie.trend == -1 && (serie.current == serie.min)) {
//                         serie.trend = -2;
//                     }
//                     trend_area.find('.popup-chart-loading').hide();
//
//                     var drawOptions = {
//                         popup_dom: trend_area,
//                         istb: istb,
//                         dp_id: dp_id,
//                         series: [serie],
//                         promo_series: promo_serie ? [promo_serie] : [],
//                         promotions: _promotions[dp_id + '-' + position],
//                         quan_price: Number(quan_price),
//                         show_legend: show_chart_legend,
//                         currency: dp_currencies[dp_id] ? dp_currencies[dp_id] : '&yen;',
//                         callback_before_draw: function (chart_options) {
//                             if (chart_options.series.length === 1) {
//                                 var trend_area_w = trend_area.width();
//                                 var _h = 330;
//                                 trend_area.css({'height': _h+'px', 'background-size': trend_area_w + 'px '+_h+'px'})
//                             }
//                         },
//                         callback_after_draw:  function (chart) {},
//                     }
//                     PopupTrend.init(chart_id,drawOptions);
//                 } else {
//                     // no data
//                     trend_area.find('.popup-chart-loading>p').text('暂无价格走势')
//                     trend_area.find('.area-head,.popup-chart-loading,.area-content').hide()
//                     trend_area.find(".no-data").show();
//                 }
//             }, 2, 1, 0);
//         }
//     }, function () {
//         $(this).siblings('.popup-trend-area').toggleClass('active');
//     });
//
//     $('#tab_wrap #tab_where_buy .popup-trend-area').hover(function () {
//         $(this).toggleClass('active')
//     },function () {
//         $(this).toggleClass('active')
//     });
// }

function getCoupon(item) {
  var dpid = $(item).data('dp-id')
  var tpl_now = $('#tpl_now').text()
  if (dpid.endsWith('-3') || dpid.endsWith('-370')) {
    $.get(apiPrefix + '/api/coupon?dpId=' + dpid).then((res) => {
      console.log(res)
      if (res.coupon) {
        $(item)
          .find('.dp-info .quan')
          .text(res.coupon + '元券')
          .addClass('active')
          .css('display', 'inline-flex')
      }
    })
    return
  }
  if (dpid) {
    $.ajax({
      url: apiPrefix + '/api/privilege_trans',
      data: {
        dp_id: dpid,
        from: window.transUrlPosition
          ? window.transUrlPosition
          : tpl_now == 'trend'
          ? 'trend'
          : 'gwd_dp',
      },
      success: function (resp) {
        if (resp.code == 0 && resp.data !== 'undefined') {
          let c = resp.data[dpid]
          if (c.coupon_amount > 0) {
            $(item)
              .find('.dp-info .quan')
              .text(c.coupon_amount + '元券')
              .addClass('active')
              .css('display', 'inline-flex')
            $(item).find('.dp-info .bottom .quan-title').addClass('active')
            let price = $(item)
              .find('.dp-info .bottom .price')
              .text()
              .trim()
              .substr(1)
            $(item)
              .find('.dp-info .bottom .price')
              .html(
                '&yen;' +
                  parseFloat(parseFloat(price) - c.coupon_amount).toFixed(2)
              )
            $(item)
              .find('.dp-info .bottom .popup-trend')
              .attr(
                'quan-price',
                parseFloat(parseFloat(price) - c.coupon_amount).toFixed(2)
              )
          }
        }
      },
      dataType: 'json',
    })
  }
}

$(window).scroll(function () {
  document.querySelectorAll('.dp-item').forEach(function (item) {
    if (
      isInView(item) &&
      !$(item).hasClass('coupon_loaded') &&
      $(item).parents('.zmpubBox').css('display') != 'none'
    ) {
      $(item).addClass('coupon_loaded')
      getCoupon(item)
    }
  })

  if (tpl === 'trend') {
    if ($('#trend-where-buy').length && isInView($('#trend-where-buy')[0])) {
      const dom = $($('#trend-where-buy')[0])
      if (undefined === dom.data('product-same-status')) {
        dom.data('product-same-status', 'loading')

        getSameProduct(function () {
          console.log('callbacking')
          dom.data('product-same-status', 'loaded')

          // hoverPriceHistory();
          jQuery('#btn-show-onsale').bind('click', showOnSale)

          whereBuySiteItemClick()
        })
      }
    }
  }
})

if (tpl !== 'trend') {
  // hoverPriceHistory();
  $('.popup-trend')
    .toArray()
    .forEach((item) => {
      let dpId = $(item).attr('data-dp-id')
      new Vue({
        el: item,
        render: (h) =>
          h(PopupTrend, {
            props: {
              dp_id: dpId,
              getCurrency: () => '¥',
            },
            style: {
              marginTop: 0,
              marginLeft: '10px',
            },
          }),
      })
    })
  whereBuySiteItemClick()
}

function createLazyloadImg(
  url,
  id = null,
  alt = null,
  defaultUrl = '/template/metro/images/dp/loading.png',
  width = null,
  height = null
) {
  if (!url) {
    return ''
  }
  url = url.replace('http:', 'https:')

  let s = `<img class="lazy" data-original="${url}" src="${defaultUrl}"`
  if (id) {
    s += ` id=${id}`
  }
  if (alt) {
    s += ` alt=${alt} title=${alt}`
  }
  if (width) {
    s += ` width=${width}`
  }
  if (height) {
    s += ` height=${height}`
  }
  s += '>'
  return s
}

function b2cProduct(b2c) {
  let s = ''
  let noStockCnt = 0
  const createPromos = function (promos) {
    const L = promos.length
    let p = ''
    if (L) {
      const maxWidth = L === 1 ? '100%' : '194px'
      promos.forEach((dpPromo) => {
        let pId = dpPromo.type == 'coupon' ? 'quan' : 'hui'
        let pIcon =
          dpPromo.type == 'coupon'
            ? '/template/metro/images/dp/icon_quan.png'
            : '/template/metro/images/dp/icon_hui.png'
        p += `<div id="${pId}" class="quan">
                        <img class="promo-icon" src="${pIcon}">
                        <span title="${dpPromo.text}" style="max-width: ${maxWidth};">${dpPromo.text}</span>
                    </div>`
      })
    }
    return p
  }

  if (b2c.length) {
    let index1 = 0
    b2c.forEach((siteProduct, siteIndex) => {
      let index2 = 0
      siteProduct.products.forEach((product) => {
        if (!Number(product.stock)) {
          noStockCnt++
        }
        let dp_id = product.dp_id
        let is_tb = [83, 123, 8].indexOf(Number(product.site_id)) >= 0

        let sPromos = createPromos(product.promos)
        let sCnt = ''
        if (undefined !== product.comment_cnt && product.comment_cnt) {
          sCnt = `<span class="num fr">评论数: ${formatNum(
            product.comment_cnt
          )}</span>`
        }

        let sVip = ''
        let pos = 'search_comp'
        if (location.href.indexOf('/trend/') > -1) {
          pos = 'trend_comp'
        }
        if (product.vip.length) {
          sVip = '<div class="vip">'
          if (product.vip.type === 'plus') {
            sVip += `<div class="img jd-plus" title="京东PLUS价格"></div><span>&yen;${product.vip.text}</span>`
          }
          sVip += '</div>'
        }

        const prefix =
          siteProduct.site_icon.indexOf('http') === 0 ? '' : apiPrefix

        if (siteProduct.site_icon)
          s += `<div class="b2c">
<div class="dp-item ${index2 === 0 ? 'first' : ''} ${
            is_tb ? 'tb' : ''
          }" data-dp-id="${dp_id}" data-onsale="${
            product.stock
          }" data-site-anchor="${index1}">
<div class="left">
    <div id="site${index1}"></div>
    <div class="site-info">
        <img src="${prefix}${siteProduct.site_icon}" alt="${
            siteProduct.site_name
          }" class="site-icon">
        <p>${siteProduct.site_name}</p>
    </div>
</div>

<div class="right col02">
    <div class="dp-img pic1">
        <a rel="nofollow" isconvert="0" target="_blank" href="${
          product.jump_url
        }" title="${product.title}" istransurl="${
            product.convert
          }" transurl-type="item" transurl-data="${
            product.dp_id
          }" transurl-site="${product.site_id}" transurl-position="${pos}">
            ${createLazyloadImg(
              product.img_url,
              '',
              product.title,
              isBjg ? '/bjg/images/bjg/loading.png' : ''
            )}        
        </a>
    </div>
    <div class="dp-info">
        <a target="_blank" class="title" title="${
          product.title
        }" isconvert="0" href="${product.jump_url}" istransurl="${
            product.convert
          }" transurl-type="item" transurl-data="${
            product.dp_id
          }" transurl-site="${product.site_id}" transurl-position="${pos}">${
            product.title
          }</a>
        <div class="promos">
            <a id="quan" href="${
              product.coupon_url
            }" class="quan" target="_blank" style="display: none;"></a>
            <div class="promos-wrapper">
                ${sPromos}
            </div>
            ${sCnt}
        </div>
        ${sVip}
        
        <div class="bottom">
            <span class="quan-title">券后:&nbsp;&nbsp;</span>
            <span class="price">${product.currency}${keep2Decimals(
            product.price / 1e2
          )}</span>
            <div class="popup-trend" data-dp-id="${
              product.dp_id
            }" data-site-name="${product.site_name}">价格走势</div>
            <div class="product-site" title="${product.site_name}">
                <img src="https://cdn.gwdang.com/images/favicon/${
                  product.site_id
                }.png" class="site-icon">
                <span class="site-name">${product.site_name}</span>
            </div>
            
        </div>
        
        <a target="_blank" style="${
          !Number(product.stock) ? 'color: white' : ''
        } " class="buy ${!Number(product.stock) ? 'no-stock' : ''}" href="${
            product.jump_url
          }" isconvert="0" istransurl="${
            product.convert
          }" transurl-type="item" transurl-data="${
            product.dp_id
          }" transurl-site="${product.site_id}" transurl-position="${pos}">${
            Number(product.stock) ? '去看看' : '缺货中'
          }</a>
    </div>
</div>
</div>
</div>`
        ++index2
      })

      index1++
    })
  }

  return [s, noStockCnt]
}

function tbProduct(tb, type = 'tmall', length = 0) {
  let s = ''
  let pos = 'search_comp'
  if (location.href.indexOf('/trend/') > -1) {
    pos = 'trend_comp'
  }
  window.transUrlPosition = pos + '_website'
  if (tb.product.length) {
    tb.product.forEach((item, index) => {
      let s1 = ''
      let s2 = ''
      if (index === 0) {
        s1 = `<div id="site${length}"></div>
                        <img class="site-icon" src="${apiPrefix}/images/sites/${item.site_id}.gif">
                        <p>${item.site_name}</p>`
      }

      if (item.volume) {
        s2 = `<span class="num fr">销量: ${formatNum(item.volume)}</span>`
      }

      if (!item.dpid.includes('-')) {
        item.dpid = item.dpid + '-' + item.site_id
      }

      s += `<div class="dp-item tb" data-dp-id="${item.dpid}" data-onsale='1'>
    <div class="left">
        ${s1}
    </div>
    
    <div class="right">
        <div class="dp-img pic">
            <a href="${
              item.go_url
            }" target="_blank" isconvert="0" istransurl="1" transurl-type="item" transurl-data="${
        item.dpid
      }" transurl-site="${item.site_id}" transurl-position="${pos}">
                <img class="lazy" data-original="${item.pic_url}" src="${
        isBjg
          ? '/bjg/images/bjg/loading.png'
          : '/template/metro/images/dp/loading.png'
      }" onerror="this.src='/bjg/images/bjg/loading.png'">
            </a>
        </div>
        <div class="dp-info">
            <p class="title">
                <a href="${
                  item.go_url
                }" target="_blank" isconvert="0" istransurl="1" transurl-type="item" transurl-data="${
        item.dpid
      }" transurl-site="${item.site_id}" transurl-position="${pos}">${
        item.title
      }</a>
            </p>
            <div class="promos">
                 <a id="quan" class="quan" target="_blank" href="/bjg/product/get_trans?dp_id=${
                   item['dpid']
                 }&direct=1&from=trend_comp_website"></a>
                 ${s2}           
            </div>
            
            <div class="bottom">
                <span class="quan-title">券后:&nbsp;&nbsp;</span>
                <span class="price">&yen;${item.price.replace(',', '')}</span>
                <div class="popup-trend" data-dp-id="${
                  item.dpid
                }" data-site-name="${
        type === 'tmall' ? '天猫' : '淘宝'
      }">价格走势</div>
                <div class="product-site" title="${item.site_name}">
                    <img src="https://cdn.gwdang.com/images/favicon/${
                      type === 'tmall' ? 83 : 123
                    }.png" class="site-icon">
                    <span class="site-name">${item.site_name}</span>
                </div>
                
            </div>
            <a href="${
              item.go_url
            }" target="_blank" class="buy" isconvert="0" istransurl="0" transurl-type="item" transurl-data="${
        item.dpid
      }" >去看看</a>
        </div>
    </div>
</div>`
    })
  }

  return s
}

async function getSameProduct(successCallback = null) {
  try {
    const { b2c, tb } = await ProductSame.getList(dp_id, title, price, 'trend')
    const position = 'history_bijia'

    if (
      b2c.length ||
      tb['taobao']['product'].length ||
      tb['tmall']['product'].length
    ) {
      $('.more_price_line#trend-where-buy').prepend(
        '<h2 class="titWrap"><span class="labeledTitle">更多报价</span></h2>' +
          '<div id="tab_wrap"><div id="tab_where_buy" class="zmpubBox">' +
          '<div class="compare-site-list">' +
          '<ul class="where_buy_on_sale_anchor_list"></ul>' +
          '<div class="options"><div id="btn-show-onsale" class="opt-item"><i class="opt-icon icon-check"></i><span>只看有货</span></div></div>' +
          '</div>' +
          '<div class="bd price_comparison"><div class="list"></div></div>' +
          '</div></div>'
      )

      const siteList = []
      if (b2c.length) {
        b2c.forEach((value) => {
          siteList.push({
            name: value.site_name,
            icon: value.site_icon,
            site_id: value.site_id,
          })
        })
      }
      if (tb['tmall']['product'].length) {
        siteList.push({
          name: '天猫商城',
          icon: 'http://cdn.gwdang.com/images/sites/83.gif',
          site_id: 83,
        })
      }
      if (tb['taobao']['product'].length) {
        siteList.push({
          name: '淘宝网',
          icon: 'http://cdn.gwdang.com/images/sites/123.gif',
          site_id: 123,
        })
      }

      let s = ''
      siteList.forEach((site, index) => {
        s += `<li class='where_buy_on_sale_anchor' id=${index}><a id=${index}>${site.name}</a></li>`
      })
      $('.more_price_line#trend-where-buy')
        .find('.where_buy_on_sale_anchor_list')
        .append(s)

      let s1 = b2cProduct(b2c)
      $(
        '.more_price_line#trend-where-buy #tab_where_buy .price_comparison .list'
      ).append(s1[0])

      if (s1[1] == 0) {
        $('.more_price_line#trend-where-buy')
          .find('.compare-site-list .options')
          .remove()
      }

      if (tb['tmall']['product'].length || tb['taobao']['product'].length) {
        $(
          '.more_price_line#trend-where-buy #tab_where_buy .price_comparison .list'
        ).append(
          '<div class="divider-line"><p></p><p>天猫淘宝相似款</p><p style="width: 377px;"></p></div>'
        )
      }

      s = tbProduct(tb['tmall'], 'tmall', b2c.length)
      $(
        '.more_price_line#trend-where-buy #tab_where_buy .price_comparison .list'
      ).append(s)

      s = tbProduct(
        tb['taobao'],
        'taobao',
        b2c.length + (tb['tmall']['product'].length ? 1 : 0)
      )
      $(
        '.more_price_line#trend-where-buy #tab_where_buy .price_comparison .list'
      ).append(s)
    }

    $('.popup-trend')
      .toArray()
      .forEach((item) => {
        let dpId = $(item).attr('data-dp-id')
        new Vue({
          el: item,
          render: (h) =>
            h(PopupTrend, {
              props: {
                dp_id: dpId,
                getCurrency: () => '¥',
              },
              style: {
                marginTop: 0,
                marginLeft: '10px',
              },
            }),
        })
      })
  } catch (e) {
    console.error(e)
  } finally {
    console.log('success callback')
    $('img.lazy').lazyload()
    'function' === typeof successCallback && successCallback()
  }
}

// 比价商城筛选
function whereBuySiteItemClick() {
  // 商城比价锚点跳转
  let anchor_height = $('.where_buy_on_sale_anchor').height()
  $('.where_buy_on_sale_anchor a').click(function () {
    let pos_top = anchor_height + 50
    let anchor_name = $(this).attr('id')
    let anchor_ele = $('#site' + anchor_name)
    $('html,body').animate(
      { scrollTop: anchor_ele.offset().top - pos_top },
      300
    )
  })
}

// 只看有货
function showOnSale() {
  let no_stocks = $('.price_comparison .list').find('.dp-item[data-onsale=0]')
  if ($(this).hasClass('active')) {
    no_stocks.removeClass('dp-hide')
    no_stocks.each(function (index, item) {
      if ($(item).hasClass('first')) {
        let site_anchor = $(item).data('site-anchor')
        $(item)
          .find('.left #site' + site_anchor + '-')
          .attr('id', 'site' + site_anchor)
      }
    })
    $('.price_comparison .list')
      .find('.dp-item[data-onsale=1]')
      .removeClass('hide-first')
    $(
      '.compare-site-list .where_buy_on_sale_anchor_list .where_buy_on_sale_anchor'
    ).removeClass('anchor-hide')
  } else {
    no_stocks.addClass('dp-hide')
    no_stocks.each(function (index, item) {
      if ($(item).hasClass('first')) {
        let site_anchor = $(item).data('site-anchor')
        $(item)
          .find('.left #site' + site_anchor)
          .attr('id', 'site' + site_anchor + '-')
        let t = $('.price_comparison .list').find(
          '.dp-item[data-site-anchor=' + site_anchor + '][data-onsale=1]'
        )
        if (t.length) {
          $(t[0]).addClass('hide-first')
        } else {
          $(
            '.compare-site-list .where_buy_on_sale_anchor_list .where_buy_on_sale_anchor[id=' +
              site_anchor +
              ']'
          ).addClass('anchor-hide')
        }
      }
    })
  }
  $(this).toggleClass('active')
}

if (tpl !== 'trend') {
  jQuery('#btn-show-onsale').bind('click', showOnSale)
}

// 从这里开始新增拼多多比价
;(async function () {
  if (tpl === 'product' || tpl === 'product_middlepage') {
    const signParams = function (data) {
      const fp = Cookies.getItem('fp')
      const keys = Object.keys(data)
      keys.sort()

      let t = []
      keys.forEach((k) => {
        t.push(`${k.toString()}=${data[k]}`)
      })

      let s = t.join('*')
      s += `*fp=${fp}`
      const md5 = require('md5')
      return md5(s)
    }

    const timestamp = new Date().getTime()
    let title = ''
    if (tpl === 'product_middlepage') {
      title = $('div.product-detail > div.detail-l > a').attr('title')
    }
    title = title.replace(/ /g, '+')

    const str = signParams({
      dp_id,
      price,
      title,
      timestamp,
    })
    let html = ''

    await utils.HttpRequest.get(
      '/mapp/v3/market_products',
      {
        dp_id,
        filters: 'similar2',
        str,
      },
      { dataType: 'json' }
    ).then((res) => {
      if (res.data.length === 0) {
        $(
          '#tab_where_buy > div.bd.price_comparison > div > div.divider-line > p:nth-child(2)'
        ).text('淘宝比价')
        return
      }
      if ($('.divider-line').length === 0) {
        $('#pddSame').append(
          `<div class="divider-line"><p></p><p>拼多多比价</p><p style="width: 377px;"></p></div>`
        )
      }
      let data = res.data.pin.list
      for (let index = 0; index < data.length; index++) {
        const element = data[index]
        html = `<div class="dp-item tb coupon_loaded" data-dp-id="${
          element.dpid
        }" data-onsale="1">
        ${
          index === 0
            ? '<div class="left"><img class="site-icon" src="/images/sites/370.gif" alt="拼多多"><p>拼多多</p></div>'
            : '<div class="left"></div>'
        }
        <div class="right">
          <div class="dp-img pic">
            <a href="https://www.gwdang.com/product/get_trans?direct=1&from=product_bijia&dp_id=${
              element.dpid
            }"
              target="_blank" isconvert="0" istransurl="1" transurl-type="item"
              transurl-data="${element.dpid}" transurl-site="${element.site_id}"
              transurl-position="search_comp">
              <img class="lazy"
                data-original="${element.img_url}"
                src="/template/metro/images/dp/loading.png">
            </a>
          </div>
          <div class="dp-info">
            <p class="title">
              <a href="https://www.gwdang.com/product/get_trans?direct=1&from=product_bijia&dp_id=${
                element.dpid
              }"
                target="_blank" isconvert="0" istransurl="1" transurl-type="item"
                transurl-data="${element.dpid}" transurl-site="${
          element.site_id
        }"
                transurl-position="search_comp">${element.title}</a>
            </p>
            <div class="promos">
              <a id="quan"
                href="https://www.gwdang.com/product/get_trans?direct=1&from=product_bijia&dp_id=${
                  element.dpid
                }"
                class="quan" target="_blank" ${
                  element.coupon_detail ? 'style="display: inline-flex;"' : ''
                }>${
          element.coupon_detail ? element.coupon_detail.discount + '元券' : ''
        }</a>
                <span class="num fr">销量: ${element.sale_cnt}</span>
            </div>
            <div class="bottom">
              <span class="quan-title ${
                element.coupon_detail ? 'active' : ''
              }">券后:&nbsp;&nbsp;</span>
              <span class="price">¥${
                element.coupon_detail
                  ? (element.price - element.coupon_detail.discount).toFixed(2)
                  : element.price.toFixed(2)
              }</span>
              <div class="popup-trend" data-dp-id="${
                element.dpid
              }" data-site-name="${element.site_name}">价格走势</div>
              <div class="product-site" title="${element.site_name}">
                <img src="https://cdn.gwdang.com/images/favicon/370.png" class="site-icon">
                <span class="site-name">${element.site_name}</span>
              </div>
            </div>
            <a href="https://www.gwdang.com/product/get_trans?direct=1&from=product_bijia&dp_id=${
              element.dpid
            }"
              target="_blank" class="buy" isconvert="0" istransurl="1" transurl-type="item"
              transurl-data="${element.dpid}" transurl-site="${element.site_id}"
              transurl-position="search_comp">去看看</a>
          </div>
        </div>
      </div>`
        $('#pddSame').append(html)
        $('#pddSame img.lazy').lazyload()
      }
    })

    $('.popup-trend')
      .toArray()
      .forEach((item) => {
        let dpId = $(item).attr('data-dp-id')
        new Vue({
          el: item,
          render: (h) =>
            h(PopupTrend, {
              props: {
                dp_id: dpId,
                getCurrency: () => '¥',
              },
              style: {
                marginTop: 0,
                marginLeft: '10px',
              },
            }),
        })
      })
  }
})()
